module.exports = __webpack_public_path__ + "img/resource_center.1de4f83a.png";